// extracted by mini-css-extract-plugin
export var button = "_4p-7";
export var buttonRow = "_4p-6";
export var fadeIn = "_4p-1";
export var gradient = "_4p-0";
export var panel = "_4p-2";
export var panelIn = "_4p-3";
export var subtitle = "_4p-5";
export var title = "_4p-4";